<template>
  <v-flex xs3>
    <label class="v-label theme--light">{{ schema.$schema.title }}</label>

    <v-spacer />

    <v-layout column style="margin-top: 0.5em">
      <v-card elevation="0" class="border-dash">
        <v-card-title class="justify-center px-0 text-xs-center d-flex flex-column">
          <div class="v-card-h2">Przeciągnij załącznik, aby dodać</div>

          <div>
            <v-icon large>mdi-upload</v-icon>
          </div>
        </v-card-title>
      </v-card>

      <file-upload
        ref="upload"
        v-model="files"
        class="v-btn add-file__button theme--light pointer v-size--large d-flex mb-4"
        :accept="accept"
        :size="size"
        :multiple="multiple"
        :post-action="linkPOST"
        :drop="true"
        :drop-directory="true"
        @input-file="saveToSchema"
      >
        <span>Dodaj plik ręcznie</span>
      </file-upload>

      <v-card-title v-if="files.length" class="d-flex flex-column align-start px-0 py-2 separate--after">
        <div class="v-card-h2">Pliki:</div>

        <ul v-if="files.length" class="v-card-h4 mb-4">
          <li v-for="file in files" :key="file.id" class="mt-2">
            <span>{{ file.name }}</span>
            -
            <span>{{ file.size | formatSize }}</span>
            -
            <span v-if="file.error">błąd</span>

            <span v-else-if="file.success">wysłano</span>

            <span v-else-if="file.active">wysyłam</span>

            <span v-else>czeka na wysłanie</span>
            -
            <a @click.prevent="removeFile(file)">Usuń</a>
          </li>
        </ul>
      </v-card-title>

      <div v-if="files.length" style="display: none">
        <v-btn
          v-if="!$refs.upload || !$refs.upload.active"
          block
          class="primary"
          @click.prevent="$refs.upload.active = true"
        >
          <span v-if="multiple">Wyślij pliki</span>

          <span v-else>Wyślij Plik</span>
        </v-btn>

        <v-btn v-else block class="danger" @click.prevent="$refs.upload.active = false">Przerwij wysyłanie</v-btn>
      </div>
    </v-layout>

    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Upuść plik</h3>
    </div>

    <p class="error--text">{{ schema.$error }}</p>
  </v-flex>
</template>

<script>
import { mediaResource } from '@witkac/kartamiejska-resources';
import { formatSize } from '@witkac/kartamiejska-shared';
import FileUpload from 'vue-upload-component';

import { notificationsMixin } from '@/mixins/notifications';
import { config } from '@/utils/config';

// @vuese
// @group Components/Forms
// Input na media
export default {
  components: { FileUpload },

  filters: {
    formatSize
  },

  mixins: [notificationsMixin],

  props: {
    // schema
    schema: { type: Object, required: true },
    // akceptowane typy plików
    accept: { type: String, required: false },
    // maksymalny rozmiar; 0 = brak limitu
    size: { type: Number, default: 30 * 1024 * 1024 }
  },

  data() {
    return {
      files: [],
      linkPOST: config.mediaURL
    };
  },

  computed: {
    multiple() {
      return this.schema.$schema.type === 'array';
    }
  },

  mounted() {
    this.loadFile();
  },

  methods: {
    // @vuese
    // Wysyłam do schemy
    saveToSchema(newFile) {
      if (this.accept && (!this.accept.includes(newFile.type) || !newFile.type)) {
        this.removeFile(newFile);
        this.notifyError('Nieprawidłowy format pliku.');
        return;
      }

      if (this.size && newFile.size > this.size) {
        this.removeFile(newFile);
        this.notifyError('Plik zbyt duży.');
        return;
      }

      if (!newFile.active && !newFile.success) {
        this.$refs.upload.active = true;
        return;
      }

      if (!newFile.success) {
        return;
      }

      const id = this.fileMediaId(newFile);
      if (this.multiple) {
        this.schema.$addRow(id);
      } else if (this.schema.$schema.type === 'number') {
        this.schema.$setData(id);
      } else {
        this.schema.$setData(id.toString());
      }
    },

    // @vuese
    // Usuwa plik
    removeFile(fileToRemove) {
      const index = this.files.findIndex(file => file.id === fileToRemove.id);
      this.files.splice(index, 1);
      if (fileToRemove.success) {
        this.removeFileFromSchema(fileToRemove);
      }
    },

    // @vuese
    // Usuwa plik ze schemy
    removeFileFromSchema(fileToRemove) {
      if (this.multiple) {
        const index = this.schema.$model.indexOf(this.fileMediaId(fileToRemove));
        this.schema.$removeRow(index);
      } else {
        this.schema.$setData(null);
      }
    },

    // @vuese
    // Zwraca identyfikator medii przypisanej do pliku
    fileMediaId(file) {
      if (file.response && file.response.id) {
        return file.response.id;
      }
      if (file.xhr && file.xhr.response) {
        return JSON.parse(file.xhr.response).id;
      }
      return file.id;
    },

    // @vuese
    // Ładowanie pliku
    loadFile() {
      const mediaIds = [];
      if (this.multiple) {
        mediaIds.push(...this.schema.$model);
      } else if (this.schema.$model) {
        mediaIds.push(parseInt(this.schema.$model));
      }
      if (!mediaIds.length) {
        return;
      }

      Promise.all(
        mediaIds.map(mediaId =>
          mediaResource
            .getMedia(mediaId)
            .then(mediaInfo => {
              const file = { ...mediaInfo, type: mediaInfo.contentType, success: true, name: mediaInfo.title };
              this.files.push(file);
            })
            .catch(() => this.$store.dispatch('notifyError', { title: 'Nie udało się pobrać pliku' }))
        )
      );
    }
  }
};
</script>

<style>
.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
